const withCommends = (state, action, clear = true) => {
  //console.log('WITH COMMENDS DATA', action);
  const data = action.data.topics ? 
    action.data.topics : action.data.topic ? 
    [action.data.topic, ...action.data.topic.comments] : action.data.comments ? 
    [...action.data.comments] : action.data.lenta ?
    [...action.data.lenta] : [];
  //const type = action.data.topics ? 'thread' : action.data.topic ? 'topic' : action.data.lenta ? 'lenta' : '';
  const type = action.type;
  //console.log('WITH COMMENDS DATA', data, type, action);
  //console.log('WITH COMMENDS DATA', data);
  //return {
  const res = {
    ...state,
    //commends: Object.assign(state.commends: {}, 
    commends: Object.assign(clear ? Object.fromEntries(Object.entries(state.commends).filter(([k, v]) => v.type != type)) : state.commends,
      ...data.map(e => ({[e.id]: {plus: e.plus, minus: e.minus, commended: e.commended, bookmarked: e.bookmarked, type}})))
  };
  //console.log('WITH COMMENDS', res.commends);
  return res;
};

export const forum = (state = [], action) => {
  switch (action.type) {
    case 'ADD_PLUS': 
    case 'ADD_MINUS': 
    case 'REMOVE_PLUS':
    case 'REMOVE_MINUS': 
      return {
        ...state,
        commends: Object.assign(state.commends, ({[action.data.id]: {
          plus: action.data.plus,
          minus: action.data.minus,
          commended: action.data.commended,
        }}))
      };
    case 'UPDATE_WIDTH':
      return {...state, navPanelWidth: action.data};
    case 'GET_THREADS':
      return {...state, threads: action.data};
    case 'GET_THREAD':
      return withCommends({...state, thread: action.data}, action);
    case 'GET_TOPIC':
      return withCommends({...state, topic: action.data}, action);
    case 'GET_LENTA':
      //console.log('REDUX STATE', state.lenta);
      return withCommends({...state, lenta: {topics: action.data.lenta, champs: action.data.champs, len: action.data.len}}, action);
    case 'ADD_TO_LENTA':
      //console.log('REDUX STATE', state.lenta.topics, action.data.lenta);
      return withCommends({...state, lenta: {
        topics: state.lenta.topics.concat(action.data.lenta), 
        champs: action.data.champs, 
        len: state.lenta.len/*len: action.data.len*/
      }}, action, false);
    case 'MORE_COMMENTS':
      return withCommends({...state}, action, false);
    case 'MORE_TOPICS': 
      return withCommends({...state}, action, false);
    case 'ADD_BOOKMARK': 
      //console.log('ADDING BOOKMARK', action.data, state.commends[action.data.id]);
      return {
        ...state,
        commends: {
          ...state.commends,
          [action.data.id]: {...(state.commends[action.data.id] || {}), bookmarked: true}, 
        }
      };
    case 'REMOVE_BOOKMARK': {
      //console.log('REMOVING BOOKMARK', action.data, state.commends[action.data.id]);
      return {
        ...state,
        commends: {
          ...state.commends,
          [action.data.id]: {...(state.commends[action.data.id] || {}), bookmarked: false}, 
        }
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/reducers/forum.jsx